module.exports = __webpack_public_path__ + "static/media/upp_flo_lad_acc.18c46e17.png";